<template>
    <app-dropdown
      placeholder="Filter by Packages"
      track-by="id"
      label="title"
      :options="packageSelection"
      :loading="loading"
      :disabled="dropdownDisabled"
      v-bind="attrs"
      @on-selected="onPackageSelected"
      @on-removed="onPackageRemoved"
    />
  </template>
  
  <script>
  import AppDropdown from "../AppComponents/AppDropdown.vue";
  import ApiMixin from "../../mixins/ApiMixin";
  import LookupServices from "../../services/lookups";
  
  /**
   * The value that indicates that selecting this from the
   * dropdown means the user is trying to select all
   * packages.
   */
  export const PackageListAllOption = {
    id: 0,
    title: "All Packages"
  };
  
  export default {
    mixins: [ApiMixin],
    props: ["clients"],
    components: {
      AppDropdown
    },
    computed: {
      // The rest of the attributes
      attrs() {
        const { placeholder, options, ...rest } = this.$attrs;
        return rest;
      },
      // Function to determine if the dropdown should be disabled
      dropdownDisabled() {
        if (this.loading) return true;
        if (this.attrs.disabled) return this.attrs.disabled;
  
        return false;
      },
      // Holds the data for the package selection to be displayed
      packageSelection() {
        let baseSelection = [];
        if (this.response) baseSelection = this.response.data.lookups;
  
        // Sort the package list alphabetically.
        baseSelection.sort((a, b) => a.title.localeCompare(b.title));
  
        return [PackageListAllOption, ...baseSelection];
      }
    },
    methods: {
      async fetchPackages() {
        await this.request(LookupServices.getPackages);
      },
      onPackageSelected(props) {
        this.$emit("on-package-selected", props);
      },
      onPackageRemoved(props) {
        this.$emit("on-package-removed", props);
      }
    },
    mounted() {
      this.fetchPackages();
    },
    inheritAttrs: false
  };
  </script>
  